module.exports = __webpack_public_path__ + "1507ff89e497a5524abc07b0da28ed.png";